import Permissions, { usePermissions } from '@app/src/auth/permissions'
import RequestTypeCardSelection from '@app/src/components/CreateNewRequestModal/RequestTypeSelection'
import CreationModalContainer from '@app/src/components/CreationModal/CreationModalContainer'
import { useAccessibleOrganizations } from '@app/src/context/AccessibleOrganizationsContext'
import { useAccount } from '@app/src/context/AccountContext'
import { QuestionnaireType } from '@app/src/context/CreationModalProgressContext'
import { insertIf } from '@app/src/utils/helpersTs'
import { Logos } from '@app/src/wf-constants'
import { AttachMoneyOutlined } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type RequestTypeProps = {
  setQuestionnaireType: (questionnaireType: QuestionnaireType) => void
  onClose: () => void
}

const RequestType: React.FC<RequestTypeProps> = ({ setQuestionnaireType, onClose }) => {
  const { account } = useAccount()
  const { formatMessage } = useIntl()
  const { accessibleOrganizations } = useAccessibleOrganizations()
  const { hasPermission } = usePermissions()

  const sfdrPermission = hasPermission(Permissions.INVESTMENT_USER)

  const currentOrg = accessibleOrganizations.find(org => org?.organization?.id === account?.organization?.id)

  const requestTypeCards = [
    {
      onClick: () => setQuestionnaireType(QuestionnaireType.WF),
      title: formatMessage({ id: 'form.createRequest.mainMenu.wfReportTitle' }),
      description: formatMessage({ id: 'form.createRequest.mainMenu.wfReportBody' }),
      logo: Logos.WorldfavorLogoSquareFilledBlack,
      whiteBg: true,
    },
    {
      onClick: () => setQuestionnaireType(QuestionnaireType.COMPANY),
      title: formatMessage(
        { id: 'form.createRequest.mainMenu.companyReportTitle' },
        { companyName: account?.organization?.name },
      ),
      description: formatMessage({ id: 'form.createRequest.mainMenu.companyReportBody' }),
      logo: currentOrg?.organization?.image?.url,
    },
    ...insertIf(sfdrPermission, {
      onClick: () => setQuestionnaireType(QuestionnaireType.SFDR_WITH_COMPANIES),
      title: formatMessage(
        { id: 'form.createRequest.mainMenu.sfdrReportTitle' },
        { companyName: account?.organization?.name },
      ),
      description: formatMessage({ id: 'form.createRequest.mainMenu.sfdrReportBody' }),
      icon: <AttachMoneyOutlined />,
    }),
  ]
  return (
    <CreationModalContainer onClose={onClose} overflow="visible" showProgress={false}>
      <Stack alignItems="center" p={8}>
        <Box mb={6}>
          <Typography variant="h1">{formatMessage({ id: 'form.createRequest.mainMenu.title' })}</Typography>
        </Box>
        <RequestTypeCardSelection requestTypeCards={requestTypeCards} />
      </Stack>
    </CreationModalContainer>
  )
}

export default RequestType
